/**
 * Compares two strings with numeric awareness, so "2" sorts before "10".
 */
export const compareAlphanumeric = (a: string, b: string): number =>
  a.localeCompare(b, undefined, {
    numeric: true,
    sensitivity: 'base',
  })

export const capitalizeText = (text: string) =>
  text
    .replace(/([A-Z])/g, ' $1')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')

export function includesIgnoreCase(base: string, toCheck: string): boolean {
  return base.toLowerCase().includes(toCheck.toLowerCase())
}

export const removeSpecialCharacters = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]/g, '')
}

/**
 * Extracts a title-cased display name from an email address.
 * e.g. "john.doe@example.com" → "John Doe".
 */
export const displayNameFromEmail = (raw: string | undefined | null): string =>
  raw
    ?.split('@')[0]
    ?.replace(/[._-]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase()) ?? 'Unknown'

/** Join display values, dropping empties and keeping first-seen unique order. */
export const joinUniqueDisplayValues = (
  values: readonly (string | number | undefined | null)[] | undefined
): string | undefined => {
  const unique: string[] = []
  const seen = new Set<string>()

  for (const value of values ?? []) {
    if (value === undefined || value === null || value === '') {
      continue
    }

    const displayValue = String(value)
    if (seen.has(displayValue)) {
      continue
    }

    seen.add(displayValue)
    unique.push(displayValue)
  }

  return unique.length > 0 ? unique.join(', ') : undefined
}
